import { ReactComponent as IconPictures } from "../assets/ic_picture.svg";
import { ReactComponent as IconVideos } from "../assets/ic_video.svg";
import { ReactComponent as IconAudios } from "../assets/ic_audio.svg";
import { ReactComponent as IconTexts } from "../assets/ic_text-posts.svg";
export const subscriptionsLimit = 8;
export const heightCardsOverlay = 35;
export const maxSubsCount = 100;

export const usdId = "1";
export const maticId = "2";

export const SEMI_ANNUAL_MONTHS_NUMBER = 6;
export const ANNUAL_MONTHS_NUMBER = 12;

export const maxImagesCount = 1;

export const activeStatus = 1;
export const cancelStatus = 2;
export const expiredStatus = 3;
// export const pendingStatus = 5;

export const initialOffset = 0;

export const filterStatusesSubscriptions = [
  { index: 0, name: "ALL", value: "" },
  { index: 1, name: "ACTIVE", value: "1" },
  { index: 2, name: "CANCELED", value: "2" },
  { index: 3, name: "EXPIRED", value: "3" },
  { index: 4, name: "NO_AVAILABLE", value: "4" },
];

export const subValue = "sub";
export const purchaseOptions = [
  {
    label: "OTP",
    value: "otp",
  },
  {
    label: "SUBSCRIPTION",
    value: subValue,
  },
];

export const subscriptionPriceOptions = [
  {
    label: "MONTHLY",
    value: "1",
    formValue: "monthlyPrice",
    periodLabel: "PER_MONTH",
    daysToAdd: 30,
  },
  {
    label: "SEMI-ANNUAL",
    value: "2",
    formValue: "semiAnnualPrice",
    periodLabel: "PER_HALF",
    daysToAdd: 180,
  },
  {
    label: "ANNUAL",
    value: "3",
    formValue: "annualPrice",
    periodLabel: "PER_YEAR",
    daysToAdd: 365,
  },
];

export const priceOptionsById = {
  1: "monthlyPrice",
  2: "semiAnnualPrice",
  3: "annualPrice",
};

export const postCountKeys = [
  { key: "textPostsCount", Icon: IconTexts },
  { key: "audiosCount", Icon: IconAudios },
  { key: "videosCount", Icon: IconVideos },
  { key: "imagesCount", Icon: IconPictures },
];

export const selectAllTypes = {
  selectAll: 1,
  removeAll: 2,
  nothing: 3,
};
